import { LazyPage, PipelineSourceAddSyncPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineSourceEditSyncRoute() {
  return (
    <LazyPage>
      <PipelineSourceAddSyncPage />
    </LazyPage>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId',
)({
  component: PipelineSourceEditSyncRoute,
});
